import {
  FetchBaseAuthoritiesRequest,
  FetchBaseAuthoritiesResponse,
  FETCH_BASE_AUTHORITIES,
  toFuncName
} from '@atomica.co/irori';
import { convert, RequestType } from '@atomica.co/utils';
import { functions } from '../firebase';

export default class BaseAuthorityRequest {
  public static fetchAuthorities = async (
    request: FetchBaseAuthoritiesRequest
  ): Promise<FetchBaseAuthoritiesResponse> => {
    return await new Promise((resolve, reject) => {
      const func = functions.httpsCallable(toFuncName(FETCH_BASE_AUTHORITIES));

      func(request)
        .then(res => resolve(convert(RequestType.RECEIVER, res.data)))
        .catch(error => reject(error));
    });
  };
}
